import ListingVM from './listing-vm';
export default {
  init: function(node){
    console.log('Initializing Kadenze.AdminCouponCampaignsListing');
    var campaigns_data = JSON.parse($('#coupon-campaigns-json').val());
    ko.applyBindingsWithValidation(new ListingVM(campaigns_data), node, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  }
};